<template>
  <div ref="container" class="w-full overflow-hidden bg-[#EFEFEF]">
    <div ref="track" class="flex w-max ticker__track">
      <div
        v-for="(item, index) in repeatedItems"
        :key="index"
        class="text-nowrap px-24 text-headline-4 text-neutral-70 border-r border-dashed border-neutral-100/10 h-40 inline-flex items-center gap-12"
      >
        <span class="italic">{{ item.enabler }}:</span>
        <span
          :class="
            item.status_num > 0
              ? 'text-alert-success'
              : 'text-alert-error'
          "
        >
          {{ item.status_text }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, watch } from 'vue'
import { enablers } from 'store/copa.stores'

const container = ref(null)
const track = ref(null)
const repeatedItems = ref([])

watch(
  () => enablers.value,
  async () => {
    await nextTick()

    const containerWidth = container.value.offsetWidth
    repeatedItems.value = enablers.value

    await nextTick()

    let trackWidth = track.value.scrollWidth

    while (trackWidth < containerWidth * 2) {
      repeatedItems.value.push(...enablers.value)
      await nextTick()
      trackWidth = track.value.scrollWidth
    }
  }
)
</script>

<style lang="scss" scoped>
.ticker__track {
  animation: ticker-scroll 30s linear infinite;
}

@keyframes ticker-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>
